import { fetcher } from './apiClient';

/**
 * The shape of the API response
 */
type CapturedImage = {
    url: string;
    imageRoute: string;
    timestamp: string;
};
type CapturedImages = CapturedImage[];

const capturedImageFetcher = async (url: string): Promise<CapturedImages> => {
    const capturedImagesResponse = await fetcher<CapturedImages>(url);

    return capturedImagesResponse as CapturedImages;
};

export { capturedImageFetcher };
export type { CapturedImage, CapturedImages };
